import { create } from 'zustand'

export type TickerAlert = {
  key: string
  eventId?: string
  title: string
  level: 'critical' | 'warning' | 'watch' | 'info'
  ts: number
}

type TickerState = {
  alerts: TickerAlert[]
  push(alert: TickerAlert): void
}

const MAX_ALERTS = 20

/** 顶部紧急告警滚动条队列：MQTT 直写，不进 query cache */
export const useTickerStore = create<TickerState>((set) => ({
  alerts: [],
  push: (alert) =>
    set((state) => {
      if (state.alerts.some((a) => a.key === alert.key)) return state
      return { alerts: [alert, ...state.alerts].slice(0, MAX_ALERTS) }
    }),
}))
